/** Physical constants. SI only (CLAUDE.md non-negotiable #3). */

/** Gravitational acceleration, m/s². */
export const G = 9.81;

/** Density of water, kg/m³. */
export const RHO = 1000;

/** Simulation timestep, seconds. Fixed (CLAUDE.md stack). */
export const DT_S = 60;

/** Seconds per hour / day. */
export const S_PER_H = 3600;
export const S_PER_DAY = 86400;
export const MIN_PER_DAY = 1440;

/** Below this flow, ratios and mixes fall back to their no-flow default (HYDRAULICS §10). */
export const FLOW_EPS = 1e-6;

/**
 * Guarded square root: a negative argument means a pool below a sill, which is zero
 * flow, not NaN (HYDRAULICS §10).
 */
export function gsqrt(x: number): number {
  return x > 0 ? Math.sqrt(x) : 0;
}

/** Guarded power for possibly-negative bases. */
export function gpow(x: number, p: number): number {
  return x > 0 ? Math.pow(x, p) : 0;
}

export function clamp(x: number, lo: number, hi: number): number {
  return x < lo ? lo : x > hi ? hi : x;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Smoothstep, for value-noise interpolation. */
export function smoothstep(t: number): number {
  const c = clamp(t, 0, 1);
  return c * c * (3 - 2 * c);
}

/**
 * Indexed read that fails loudly instead of returning undefined.
 * `noUncheckedIndexedAccess` is on; this keeps call sites readable without `!`.
 * Not for hot loops — those index typed arrays, which are not widened.
 */
export function at<T>(a: readonly T[], i: number): T {
  const v = a[i];
  if (v === undefined) throw new RangeError(`index ${i} out of range (length ${a.length})`);
  return v;
}
